import BookingChooseLocation from '@/components/Pages/Booking Flow/BookingChooseLocation.vue';
import BookingChooseCategory from '@/components/Pages/Booking Flow/BookingChooseCategory.vue';
import BookingChooseService from '@/components/Pages/Booking Flow/BookingChooseService.vue';
import BookingChooseTime from '@/components/Pages/Booking Flow/BookingChooseTime.vue';
import BookingCart from '@/components/Pages/Booking Flow/BookingCart.vue';
export default [
    {
        path: '',
        name: 'bookLocation',
        component: BookingChooseLocation,
    },
    {
        path: 'category',
        name: 'bookCategory',
        component: BookingChooseCategory,
    },
    {
        path: 'service',
        name: 'bookService',
        component: BookingChooseService,
    },
    {
        path: 'time',
        name: 'bookTime',
        component: BookingChooseTime,
        meta: {
            popEditingService: 'bookService',
        },
    },
    {
        path: 'cart',
        name: 'bookCart',
        component: BookingCart,
    },
];
